import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Small info icon with a Shadcn tooltip. Used to explain financial / technical
 * terms in plain Spanish for non-accounting users.
 *
 * Usage:
 *   <InfoTip text="Tu dinero real menos todo lo que debes." />
 */
export default function InfoTip({ text, className = "", iconClass = "", side = "top", testid }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="button"
            tabIndex={0}
            data-testid={testid || "info-tip"}
            aria-label="Más información"
            className={`inline-flex items-center justify-center align-middle text-current/70 hover:text-current transition-colors cursor-help ${className}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); } }}
          >
            <Info className={`w-3.5 h-3.5 opacity-70 hover:opacity-100 ${iconClass}`} strokeWidth={2}/>
          </span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-[260px] bg-[#1a1825] border border-violet-500/30 text-white/90 text-xs leading-relaxed font-normal px-3 py-2 shadow-xl"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
